import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../slices/userSlise.js';
import riskReducer from '../slices/riskSlice.js';
import ratingReducer from '../slices/ratingSlice.js';
import chatSlice from '../slices/chatSlice.js';

const reducer = {
  user: userReducer,
  risk: riskReducer,
  rating: ratingReducer,
  chat: chatSlice,
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;